import React, { useState, useEffect } from "react";
import FiltroProcesos from "./FiltroProcesos";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";
import ListHeader from "../../../components/listing/ListHeader";
import ListFooter from "../../../components/listing/ListFooter";
// IMPORTANTE: Importamos DynamicTable
import DynamicTable from "../../../components/listing/DynamicTable";

export default function ListarProcesos() {
  const [filters, setFilters] = useState({ q: "" });

  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false); // Estado de carga

  const [porPagina, setPorPagina] = useState(10);
  const [pagina, setPagina] = useState(1);

  const [showFiltro, setShowFiltro] = useState(false);

  // ========================
  //   Cargar desde backend
  // ========================
  const cargarProcesos = async () => {
    setLoading(true);
    try {
      const url = apiRoutes.procesos.listUrl({
        page: pagina - 1,
        size: porPagina,
        q: filters.q,
      });

      const data = await appFetchJson(url);

      setItems(data.items ?? []);
      setTotal(data.totalElements ?? 0);
    } catch (e) {
      console.error("Error cargando procesos", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    cargarProcesos();
  }, [filters, pagina, porPagina]);

  // ====================================================================
  // DEFINICIÓN DE COLUMNAS (1 COLUMNA CENTRADA)
  // ====================================================================
  const columns = [
    { 
      header: "Proceso", 
      accessor: "codigo",
      type: "text", 
      width: "100%",
      // CLAVE: Forzamos la alineación al centro tanto en Header como en Celda
      className: "text-center", 
      cellClass: "text-center font-medium text-gray-800 uppercase" // uppercase opcional, por si quieres forzar mayúsculas como en la imagen
    }
  ];

  return (
    <div className="page">

      <ListHeader
        title="Procesos"
        onFilterClick={() => setShowFiltro(true)}
        filters={filters}
        onClearFilters={() => {
          setFilters({ q: "" });
          setPagina(1);
        }}
        pageSize={porPagina}
        onPageSizeChange={(size) => {
          setPorPagina(size);
          setPagina(1);
        }}
        pageSizeOptions={[10, 15, 20]}
      />

      {loading && <div className="mt-4 text-center text-gray-600">Cargando...</div>}

      {/* Drawer Filtro */}
      {showFiltro && (
        <FiltroProcesos
          initialFilters={{ nombre: filters.q }}
          onSubmit={(f) => {
            setFilters({
              q: f.nombre || "",
            });
            setPagina(1);
          }}
          onClose={() => setShowFiltro(false)}
        />
      )}

      {/* === TABLA DINÁMICA === */}
      {!loading && (
        <DynamicTable 
          size="S" 
          data={items}
          columns={columns}
        />
      )}

      <ListFooter
        page={pagina}
        pageSize={porPagina}
        total={total}
        onPageChange={(p) => setPagina(p)}
      />
    </div>
  );
}